/* eslint-disable @typescript-eslint/no-this-alias */
const defaultInterval = 2000;
function checkFn(v: any) {
  if (typeof v !== 'function') {
    throw `${v} is not a function`;
  }
}
export function once() {
  return function(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const fn = descriptor.value;
    if (typeof fn !== 'function') {
      throw new Error('必须装饰函数');
    }
    let lock = false;
    return {
      ...descriptor,
      value(...args: any[]) {
        const context = this;
        if (lock) {
          return;
        }
        lock = true;
        try {
          fn.call(context, args);
        } catch (e) {
          lock = false;
        }
      },
    };
  };
}

// 用于 click 事件触发请求时加锁，事件函数只要返回个 promise 就好
export function promiseLock(
  target: any,
  propertyKey: string,
  descriptor: PropertyDescriptor
) {
  const fn = descriptor.value;
  if (typeof fn !== 'function') {
    throw 'promise lock must lock a function';
  }
  let lock = false;

  return {
    ...descriptor,
    value(...args: any[]) {
      const context = this;
      if (lock) {
        return;
      }
      lock = true;
      return Promise.resolve(fn.apply(context, args))
        .then((res: any) => {
          lock = false;
          return res;
        })
        .catch((e: PromiseRejectionEvent) => {
          lock = false;
          throw e;
        }) as any;
    },
  };
}
export function debounce(millisecond = defaultInterval) {
  return function(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const fn = descriptor.value;
    checkFn(fn);
    let timeout: any = null;
    return {
      ...descriptor,
      value(...args: any[]) {
        const context = this;
        const callNow = !timeout; // 用于判断是否为每次防抖的第一次
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(context, args);
          timeout = null;
        }, millisecond);
        if (callNow) {
          fn.apply(context, args);
        }
      },
    };
  };
}

export function throttle(
  config: {
    head?: boolean;
    tail?: boolean;
    interval?: number;
  } = {}
) {
  const { head = true, tail = false, interval = defaultInterval } = config;
  return function(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const fn = descriptor.value;
    checkFn(fn);
    let timeout: any = null;
    let prevTime = 0;

    return {
      ...descriptor,
      value(...args: any[]) {
        const context = this;
        const now = Date.now();
        if (head === false && !prevTime) {
          prevTime = now;
        }
        const wait = interval - (now - prevTime);
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (wait > interval || wait < 0) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          fn.apply(context, args);
          prevTime = now;
        } else if (tail === true && !timeout) {
          timeout = setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            prevTime = head ? Date.now() : 0;
            timeout = null;
            fn.apply(context);
          }, wait);
        }
      },
    };
  };
}
